/*eslint-disable */
export const AllRegex = {
  MobileNumber: /^\d{10}$/,
  LicenseNumber: /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/,
  VehicleNumber: Number(localStorage.getItem("customerNumber")) != 1122 ? /^[A-Za-z]{2,3}[0-9]{0,2}(?:[A-Za-z])?(?:[A-Za-z]{0,2})?[0-9]{3,4}$/ : /^[A-Za-z]{3}[A-Za-z0-9]{4}$/,
  Name: /^[a-z A-Z]+$/,
  Latitude: /^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,6})?))$/,
  Longitude: /^(\+|-)?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,6})?))$/,
  Radius: /^\d{1,}(\.\d{0,})?$/,
  Address: /^[#.0-9a-zA-Z\s\/,-_()\[\]]+$/,
  Email: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
  GSTIN: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
  PANIN: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
  Username: /^[a-zA-Z0-9]+$/,
  Pincode: /(^\d{6}$)|(^\d{6}-\d{5}$)/,
  AadharNumber: /^[01]\d{3}[\s-]?\d{4}[\s-]?\d{4}$/,
  BankAccNumber: /(^\d{9,18}$)/,
  BankIFSCcode: /(^[A-Z]{4}0[A-Z0-9]{6}$)/,
  landLineNo: /(^[0][1-9]{2}(-)[0-9]{8}$)/,
  phoneNo: /^[0-9]+$/,
  noSPace: /^[^\s].+$/,
  WITHOUT_SPECIAL_CHARECTERS_AND_SPACE : /^[A-Za-z0-9?]+$/
};

export const isNoSpace = (val) => {
  AllRegex.noSPace.test(val);
}
export const isPhoneNumber = (val) => {
  AllRegex.phoneNo.test(val);
};

export const isMobileNumber = (val) => {
  AllRegex.MobileNumber.test(val);
};

export const isLicenseNumber = (val) => {
  AllRegex.LicenseNumber.test(val);
};

export const isVehicleNumber = (val) => {
  AllRegex.VehicleNumber.test(val);
};

export const isName = (val) => {
  AllRegex.Name.test(val);
};

export const isLatitude = (val) => {
  AllRegex.Latitude.test(val);
};

export const isLongitude = (val) => {
  AllRegex.Longitude.test(val);
};

export const isRadius = (val) => {
  AllRegex.Radius.test(val);
};

export const isAddress = (val) => {
  AllRegex.Address.test(val);
};

export const isEmail = (val) => {
  AllRegex.Email.test(val);
};

export const isGSTIN = (val) => {
  AllRegex.GSTIN.test(val);
};

export const isPANIN = (val) => {
  AllRegex.PANIN.test(val);
};

export const isUsername = (val) => {
  return AllRegex.Username.test(val);
};

export const isPincode = (val) => {
  return AllRegex.Pincode.test(val);
};

export const isLandlineNo = (val) => {
  return AllRegex.landLineNo.test(val);
};

export const isFileValid = (file, validTypes, maxFileSize) => {
  if (validTypes.indexOf(file.type?.split('/')?.[1]) === -1) {
      return {error: true, message: "Invalid file type. Allowed file types are - " + validTypes.join(", ") + "."};
  }

  if (file.size > maxFileSize) {
      return {error: true, message: `File is too large. File must be less than ${maxFileSize/1000000}MB.`};
  }
  return {error: false, message: ''};
}